
import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class Input extends Vue {
    @Prop({default: ''}) customClass: string;
    @Prop({default: ''}) label: string;
    @Prop({default: ''}) value: any;
    @Prop({default: 524288 }) maxLength: number;
    @Prop({default: false}) disabled: boolean;
    @Prop({default: false}) required: boolean;
    @Prop({default: false}) autoFocus: boolean;
    @Prop({default: false}) focused: boolean;
    @Prop({default: false}) solo: boolean;
    @Prop({default: false}) loading: boolean;
    @Prop({default: undefined}) appendIcon: string;
    @Prop({default: undefined}) prependIcon: string;
    @Prop({default: undefined}) suffix: string;
    @Prop({default: false}) outlined: boolean;
    @Prop({default: true}) hideDetails: boolean;
    @Prop({default: true}) clearable: boolean;
    @Prop({default: 'Buscar...'}) placeholder: string;
    @Prop({default: 'text'}) type: string;
    @Prop({default: ''}) customId: string;
    @Prop({default() {return []}}) rules: string;
    @Prop({default:0}) index: number;
    savedFilters: string[] = []; 
    model: any = '';
    debounce:any = null;
    showPassword:boolean = false;

    get getInputType(){
      return this.showPassword ? 'text' : this.type
    }

    @Emit()
    updateSavedFiltersInTable(savedFilters){return savedFilters}

    toggleIconForPassword(){
      this.showPassword = !this.showPassword
    }

    @Emit()
    appendIconClick(){}

    @Emit()
    changeValue(value, index){}

    @Watch('savedFilters')
    observableSavedFilters(){
      this.updateSavedFiltersInTable(this.savedFilters)
    }


    @Watch('value', {immediate: true, deep: true})
    observableValue(value){
      this.model = value;
    }

    inputEvent(value){
      this.model = value;
      let self = this;
      clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            self.changeValue(value, self.index);
        }, 200);     
    }

    enterClicked(event){
      let self = this;
      clearTimeout(this.debounce);
      this.changeValue('', this.index)
    }

    removeFilterFromSavedFilters(indexToRemove){
      this.savedFilters.splice(indexToRemove, 1)
    }
    clearAllSavedFilters(){
      this.savedFilters = [];
    }

    mounted(){
        
    }

    
}
